<h1
  mat-dialog-title
  transloco="{{ data.message }}"
  [translocoParams]="i18nParams"
></h1>
<div mat-dialog-content>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
